import React from 'react';

const Footer = () => {
    return (
        <footer className="mt-5 py-3 text-center">
            <p className="text-secondary">
                Sihah &copy; {new Date().getFullYear()}
                <br/>
                Designed &amp; Developed By : <a href="https://masfikul-alam.web.app"><b>Masfik</b></a>
            </p>
        </footer>
    );
};

export default Footer;